jQuery('.up-top').on('click', function(e) {
  jQuery('html').animate({scrollTop: 0}, 'slow');
});

jQuery('.solution-tag a').on('click', function(e) {
  e.preventDefault();
  jQuery('html, body').animate({
    scrollTop: jQuery(jQuery(e.target).attr("href")).offset().top
  }, 1000);
});